import { useAsync } from '@flowwai-frontend/shared/common-components'

import {
   VerifyUsernameOTPAPIRequestType,
   VerifyUsernameOTPAPIResponseType
} from '../../services/types'

import { useLoginWithUsernameService } from '../services/useLoginWithUsernameService'

const useVerifyUsernameOTPAPI = () => {
   const loginService = useLoginWithUsernameService()

   const {
      mutateAsync: verifyUsernameOTPAPI,
      apiStatus: verifyUsernameOTPAPIStatus,
      error: verifyUsernameOTPAPIError
   } = useAsync<
      VerifyUsernameOTPAPIResponseType | unknown,
      Error,
      VerifyUsernameOTPAPIRequestType
   >(loginService.verifyUsernameOTP)

   return {
      verifyUsernameOTPAPI,
      verifyUsernameOTPAPIStatus,
      verifyUsernameOTPAPIError
   }
}

export { useVerifyUsernameOTPAPI }
